require.context('../../svg-sprite/', true, /\.svg$/);
require.context('../../svg-css/', true, /\.svg$/);